import type { CSSProperties, HTMLAttributes } from 'react';

import type { SpacingType } from '../../css/spacing';
import { spacingGenerator } from '../../css/spacing';
import { cn } from '../../utils/cva';

type BoxBaseType = {
  backgroundColor?: string;
  spacing?: SpacingType;
};

type BoxType = BoxBaseType & HTMLAttributes<HTMLDivElement>;

export const Box = (props: BoxType) => {
  const { children, spacing, style, backgroundColor, ...rest } = props;

  const generatedSpacing: CSSProperties = spacing
    ? spacingGenerator(spacing).reduce((acc, curr) => ({ ...acc, ...curr }), {})
    : {};

  return (
    <div
      style={{
        ...generatedSpacing,
        backgroundColor: backgroundColor,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
};

export const BoxTitleWithIndiacator = ({ children, className, ...rest }: BoxType) => {
  return (
    <h2 className={cn('fa text-h6 relative m-0', className)} {...rest}>
      <div className="border-r-primary1 absolute -right-6 h-full border-0 border-r-4 border-solid" />
      {children}
    </h2>
  );
};
